import React from 'react';
import { styleIcon } from '../style_icon.js';
export function DuplicateIcon({ title = 'Duplicate Icon', ...rest }) {
    const style = styleIcon(rest);
    return (React.createElement("svg", { ...style, viewBox: "0 0 15 15" },
        !style['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M14.5 4H4.5C4.22386 4 4 4.22386 4 4.5V14.5C4 14.7761 4.22386 15 4.5 15H10.5C11.325 15 12 14.325 12 13.5V12.49C12 12.2095 12.2295 11.98 12.51 11.98H13.5C14.325 11.98 15 11.305 15 10.48V4.5C15 4.22386 14.7761 4 14.5 4ZM10.5 0H0.5C0.21997 0 0 0.21997 0 0.5V10.5C0 10.78 0.21997 11 0.5 11H2.5V3.5C2.5 2.94995 2.95001 2.5 3.5 2.5H11V0.5C11 0.21997 10.78 0 10.5 0Z" })));
}
//# sourceMappingURL=duplicate_icon.js.map